import angular from 'angular';
import rwClearFieldDirective from './rw-clear-field-directive';

export default angular.module('rwClearField', []).directive('rwClearField', rwClearFieldDirective);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-clear-field/rw-clear-field-module.js